import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Button } from 'src/components';
import * as S from './styles';

const msgs = defineMessages({
  selected: { id: 'dashboard_tooltip_filter_title' },
  markAsKnown: { id: 'scenarioDetails_markWordAsKnown' },
  unmarkAsKnown: { id: 'scenarioDetails_unmarkWordAsKnown' },
  cancel: { id: 'communicate_report_modal_cancel' },
});

interface Props {
  selectedCount: number;
  sectionType: 'learned' | 'toLearn';
  onMarkAsKnown: () => void;
  onUnmarkAsKnown: () => void;
  onCancel: () => void;
}

export const BulkActionsBar: FC<Props> = ({
  selectedCount,
  sectionType,
  onMarkAsKnown,
  onUnmarkAsKnown,
  onCancel,
}) => {
  const intl = useIntl();

  if (selectedCount === 0) {
    return null;
  }

  const showMarkAsKnown = sectionType === 'toLearn';
  const showUnmarkAsKnown = sectionType === 'learned';

  return (
    <S.Container>
      <S.Content>
        <S.SelectionInfo>
          {intl.formatMessage(msgs.selected)} - {selectedCount}
        </S.SelectionInfo>
        <S.Actions>
          {showMarkAsKnown && (
            <Button
              buttonType="primary"
              buttonSize="small"
              onClick={onMarkAsKnown}
              data-testid="bulk-mark-as-known"
            >
              {intl.formatMessage(msgs.markAsKnown)}
            </Button>
          )}
          {showUnmarkAsKnown && (
            <Button
              buttonType="primary"
              buttonSize="small"
              onClick={onUnmarkAsKnown}
              data-testid="bulk-unmark-as-known"
            >
              {intl.formatMessage(msgs.unmarkAsKnown)}
            </Button>
          )}
          <Button
            buttonType="secondary"
            buttonSize="small"
            onClick={onCancel}
            data-testid="bulk-cancel"
          >
            {intl.formatMessage(msgs.cancel)}
          </Button>
        </S.Actions>
      </S.Content>
    </S.Container>
  );
};
